module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"outlets":"Outlets","total":"Total","audience":"Audience"},"pt":{"outlets":"Veículo","total":"Total","audience":"Audiência"},"es":{"outlets":"Medios de comunicación","total":"Total","audience":"Audiencia"}}')
  delete Component.options._Ctor
}
